import ApplicationController from "./application_controller"

export default class extends ApplicationController {
  static values = { event: String }

  track() {
    this.pushAnalyticsEvent(this.eventValue || "CTA-click-enter-funnel")
  }
}
